<template>
    <v-ons-page>

        <ons-toolbar class="branded">
            <div class="left">
                <a v-on:click="$router.go(-1)">
                    <svg class="icon icon-back" aria-hidden="true"></svg>
                </a>
            </div>
            <div class="center brand-toobar">
                <div class="outlet-navbar">
                    <span class="outlet-store-name">{{ outlet ? outlet.store_display_name : '' }}</span>
                </div>
            </div>
            <div class="right">

            </div>
        </ons-toolbar>

        <div class="content">
            <v-ons-progress-bar v-if="outlet == false || show_loading" indeterminate></v-ons-progress-bar>

            <div class="content-inner">
                <template v-if="outlet">
                    <v-ons-list class="section-h check-in-container list-no-divider">
                        <div class="main-header">Check in</div>
                        <v-ons-list-item>
                            <div class="center">
                                <v-ons-input placeholder="Name" float v-model="form.name"/>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item>
                            <div class="center">
                                <v-ons-input placeholder="Email or Phone Number" float v-model="form.contact_info"/>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item>
                            <div class="center">
                                <label>
                                    <v-ons-checkbox v-model="form.opt_in_email" class="check-in-label"></v-ons-checkbox>
                                    <span>Receive marketing emails such as news and promotions from {{ outlet.store_display_name }}.</span>
                                </label>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item>
                            <span class="check-in-message">Your check in data will be securely held in our system to facilitate the NHS Test and Trace programme. It will be automatically deleted after 21 days.</span>
                        </v-ons-list-item>
                        <section class="section-vh">
                            <gtc-button v-on:click="checkin" v-bind:disabled="!can_checkin" class="btn-action branded">
                                Check in
                            </gtc-button>
                        </section>
                    </v-ons-list>
                </template>
            </div>

        </div>

    </v-ons-page>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {

    props: [],

    data () {
        return {
            app: this.$root.$data.app,
            active_index: 0,
            form: {
                name: '',
                contact_info: '',
                opt_in_email: false,
            },
            show_loading: false
        }
    },

    mounted() {
        if (this.user) {
            this.form = {
                name: this.user.name,
                contact_info: this.user.email,
                opt_in_email: this.user.opt_in_email
            }
        }
    },

    methods : {
        checkin(){
            this.show_loading = true
            const outlet = this.outlet
            this.app.http.post(`outlet/${outlet.slug}/guest_check_in`, this.form)
                .then(response => {
                    this.show_loading = false
                    this.$ons.notification
                        .alert(response.data.message, { title: 'Success!' })
                        .then(() => {
                            this.$router.push({name: 'Menu'})
                        })
                })
                .catch(error => {
                    this.show_loading = false
                    this.$ons.notification
                        .alert(this.app.getResponseErrorMessage(error), { title: 'Unable to check in' })
                })
        },
    },

    computed: {
        ...mapGetters([
            'outlet',
            'user',
        ]),

        can_checkin: function(){
            const fields = ['name', 'contact_info']
            return fields.every(f => this.form[f] && this.form[f].length > 0)
        },
    },
}
</script>

<style scoped >
    .check-in-container {
        padding-top: 20px;
    }
    .check-in-label {
        margin-right:5px;
        margin-bottom:5px;
    }
    .check-in-message {
        display:block; margin:10px 0;
    }
</style>


// WEBPACK FOOTER //
// src/js/components/outlets/check_in.vue